import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
// import { ConfirmRefundTicketsModal } from "./ConfirmRefundTicketsModal";
import { getCurrencieLabel } from "../../../constants/currencies";

import ls from 'localstorage-slim';
import CheckBox from "../../../components/UI/Checkbox/CheckBox";
import { ConfirmRefundProductsModal } from "./ConfirmRefundProductsModal";

export const MySwal = withReactContent(Swal);

export const closeModalHandler = (e) => {
  MySwal.close();
};

export const RefundProductsModal = ({
  order,
  setActionLoading,
  getOrders,
}) => {
  const possibleProductsToRefund = order
    .products.filter((product) =>
      !product.refunded);

  const idsProducts = possibleProductsToRefund.map((product) => product.id);
  const [checkedProducts, setCheckedProducts] = useState(idsProducts);
  const [totalRefundAmount, setTotalRefundAmount] = useState(0);

  const canRefund = checkedProducts.length > 0;

  const currency = order.currency;

  const token = ls.get('user').token;

  const handleCheck = (e) => {
    const productId = e.target.dataset.related;
    var updatedProducts = [...checkedProducts];

    if (e.target.checked) {
      updatedProducts = [...checkedProducts, productId];
    } else {
      updatedProducts.splice(checkedProducts.indexOf(productId), 1);
    }

    setCheckedProducts(updatedProducts);
  };

  const refundProductsHandler = () => {
    const products = possibleProductsToRefund.filter((product) =>
      checkedProducts.includes(product.id)
    );

    MySwal.fire({
      title: "Are you sure you want to refund tickets?",
      html:
        <ConfirmRefundProductsModal
          products={products}
          setActionLoading={setActionLoading}
          getOrders={getOrders}
        />,
      showConfirmButton: false,
      customClass: "confirm-refund-tickets-modal",
    });
  };

  useEffect(() => {
    const chekedProductsInfo = possibleProductsToRefund.filter(p => checkedProducts.includes(p.id));
    const total = chekedProductsInfo.reduce((sum, product) => {
      return sum + product.productDefinition.price
    }, 0)

    setTotalRefundAmount(total)
  }, [checkedProducts])

  return (
    <>
      <div className="label-block">
        <span className="swal2-label">Name</span>
        <span className="swal2-label">
          <b>{order.info.firstName} {order.info.lastName}</b>
        </span>
      </div>
      <div className="label-block">
        <label className="swal2-label">Email</label>
        <label className="swal2-label">
          <b>{order.info.buyerEmail}</b>
        </label>
      </div>
      {possibleProductsToRefund.length > 0 && (
        <div className="seats-list">
          <h2 className="title">Products list</h2>
          <ProductsDescriptionModal
            products={possibleProductsToRefund}
            checkedProducts={checkedProducts}
            handleCheck={handleCheck}
            currency={currency}
          />
        </div>
      )}
      {possibleProductsToRefund.length > 1 && (
        <div className="total">
          <strong>Total refund amount: </strong>
          {totalRefundAmount}{' '}{currency}
        </div>
      )}
      <div className="swal2-actions">
        <button
          className="swal2-cancel swal2-styled"
          onClick={closeModalHandler}
        >
          Cancel
        </button>
        <button
          className="swal2-confirm swal2-styled"
          disabled={!canRefund}
          onClick={refundProductsHandler}
        >
          Refund
        </button>
      </div>
    </>
  );
};

const isChecked = (checkedProducts, id) => checkedProducts.includes(id);

const ProductsDescriptionModal = ({ products, checkedProducts, handleCheck, currency }) => {
  return products.map((product) => (
    <label key={product.id} className="checkbox-label">

      <CheckBox
        id={product.id}
        name={product.id}
        related={product.id}
        checked={isChecked(checkedProducts, product.id)}
        onChange={handleCheck}
      />

      <div>{getProductDescription(product, currency)}</div>

    </label>
  ));
};

const getProductDescription = (product, currency) => {
  let description = <>{product.productDefinition.name}</>;

  return (
    <div>
      {description}
      <div>
        <strong>Refund amount: </strong>
        {product.productDefinition.price}{' '}{currency}
      </div>
    </div>
  );
};

